



















































import Vue from 'vue'
import PreviewScreen from '@/components/PreviewScreen.vue'
import ListView from '@/components/DeviceList/ListView.vue'
import TableView from '@/components/DeviceList/TableView.vue'
import { devlst_vmode_t, dev_property_t, THUMB_SIZE_ALL, thumb_size_t } from '@/store/modules/pref'
import { Extender } from '@/types/api'
import { ppp } from '@/utils'
import { IDevice } from '@/types/model'
import mixins from 'vue-typed-mixins'
import { isDesktopMixin } from '@/mixins'

export default mixins(isDesktopMixin).extend({
  components: {
    ListView,
    TableView,
    PreviewScreen,
  },
  data: (): {
    readonly showingFields: dev_property_t[],
    THUMB_SIZE_ALL: thumb_size_t[]
  } => ({
    showingFields: ['mac', 'ip', 'connectionTime', 'groupID'],
    THUMB_SIZE_ALL
  }),
  computed: {
    thumbSize: {
      get (): thumb_size_t { return this.$s.$state.pref.deviceList.thumbSize },
      set (x: thumb_size_t): void { this.$s.pref.mutations.assignDeviceList({ thumbSize: x }) }
    },
    viewMode: {
      get: function (): devlst_vmode_t { return this.$s.$state.pref.deviceList.viewMode },
      set: function (x: devlst_vmode_t): void { this.$s.pref.mutations.assignDeviceList({ viewMode: x }) }
    },
    viewModeIcon (): string { return this.viewMode === 'plain' ? 'list' : 'view_quilt' },
    showingField: {
      get (): dev_property_t { return this.$s.$state.pref.deviceList.showingField },
      set (x: dev_property_t) { this.$s.pref.mutations.assignDeviceList({ showingField: x }) }
    }
  },
  methods: {
    clickLeftIcon () { this.$router.go(-1) },
    toggleViewMode () { this.viewMode = this.viewMode === 'plain' ? 'grouped' : 'plain' },
  },
  watch: {
    //
  },
  mounted () {
    //
  }
})
